import { render, staticRenderFns } from "./search-modal-customer-personal-input.vue?vue&type=template&id=48ba9d7d&"
import script from "./search-modal-customer-personal-input.vue?vue&type=script&lang=ts&"
export * from "./search-modal-customer-personal-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports